<template>
	<div class="w-100 d-flex flex-row">
		<router-link :to="{
			name: 'Group',
			params: {id: group.id}
			}" class="d-flex align-items-center link">
			<div>
				<avatar md :group="group" />
			</div>
			<div class="pl-4">
				<div class="font-16 font-weight-bold grey--text text--darken-1">
					{{ group.name }}
				</div>
				<div class="font-12 font-weight-bold grey--text text--darken-2">
					{{ group.users_count }} członków grupy
				</div>
				<div class="font-12 font-weight-bold grey--text pt-1">
					{{ group.description }}
				</div>
			</div>
			
		</router-link>
		<div class="ml-auto my-auto">
			<v-btn :to="{name: 'Group', params: {
				id: group.id
			}}" class="ml-auto" elevation="0">Przejdź do grupy</v-btn>
		</div>
		
	</div>
</template>

<script>
import Avatar from "@/components/Avatar";
export default {
	name: "SearchResultsGroup",
	components: {
		Avatar
	},
	props: {
		group: {
			type: Object,
			required: true
		}
	}
}
</script>
